module.exports = __webpack_public_path__ + "img/ic-info.cde3e4d1.svg";